import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { IHostService } from 'vscode/vscode/vs/workbench/services/host/browser/host.service';
import { IHostColorSchemeService } from 'vscode/vscode/vs/workbench/services/themes/common/hostColorSchemeService.service';
import { BrowserHostService } from './vscode/src/vs/workbench/services/host/browser/browserHostService.js';
import { BrowserHostColorSchemeService } from './vscode/src/vs/workbench/services/themes/browser/browserHostColorSchemeService.js';

function getServiceOverride() {
    return {
        [( IHostService.toString())]: new SyncDescriptor(BrowserHostService, [], true),
        [( IHostColorSchemeService.toString())]: new SyncDescriptor(BrowserHostColorSchemeService, [], true)
    };
}

export { getServiceOverride as default };
